export default __webpack_public_path__ + "static/media/p2.5855c5e8.gif";